module.exports = __webpack_public_path__ + "static/img/1086.262680a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1086.jpg
// module id = 268
// module chunks = 0